import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import Row from 'react-bootstrap/Row';
import Form from 'react-bootstrap/Form';
import { Field, Form as FinalForm } from 'react-final-form';
import { required, numericality, combine } from 'redux-form-validators';
import PropTypes from 'prop-types';
import { PRODUCT_PARAMETER_PERIOD_OPTIONS } from '../../../constants';
import FormNavigation from '../../common/FormNavigation';
import {FlexFormCol, OuterFormColLeft, OuterFormColRight, StyledExplanation} from "../../common/styles/FormStyles";
import InputWrapper from '../../common/forms/InputWrapper';
import SelectWrapper from '../../common/forms/SelectWrapper';
import { Switcher } from '../../Switcher/Switcher';
import { MAIN_COLOR, NO_ACTIVE_BG_COLOR } from '../../../constants/css';
import { parseStrToNumber } from '../../../utils/commonUtils';
import { ReactComponent as Info } from "../../../images/icons/INfo.svg";
import _ from 'lodash';
import FallbackTariffSelector from "../../common/lib/FallbackTariffSelector"

const extendExplanation = "Außerdem müssen die gültigen AGBs sowie ein Dokument zur Widerrufsbelehrung hochgeladen werden. Beide Dokumente werden Neukunden mit ihrer Auftragsbestätigung zugestellt."

class ProductContractParameterForm extends React.Component {
  renderContractValidityFields(automaticProlongation, disabled, isProducer) {
    if (!automaticProlongation) return null;
    return(
      <Field
        name="automatic_prolongation_time"
        type="number"
        labelText="Vertragslaufzeit nach automatischer Verlängerung"
        component={InputWrapper}
        validate={combine(
          required(),
          numericality({ int: true, msg: 'Ungültige Eingabe', allowBlank: true })
        )}
        parse={parseStrToNumber}
        disabled={disabled}
        unit="Monate"
        className="mt-5"
        infoIcon={!isProducer ? <Info/> : null}
        infoIconTooltip="Laut dem Gesetz für faire Verbraucherverträge dürfen Vertragslaufzeiten nur maximal um einen weiteren Monat verlängert werden."
      />
    );
  }

  render() {
    const { values, handleSubmit, form } = this.props;
    const automaticProlongation = values.is_automatic_prolongation === true
    const isSpot = values.consumption_price_model === "spot"
    const isRlm = values.product_category === "rlm"
    return (
      <Form onSubmit={handleSubmit}>
        <StyledExplanation>
          Hier können Sie Vertragsparameter festlegen, welche für alle
          Kundenverträge gelten. {!this.props.isSpot && <>{extendExplanation}</>}
        </StyledExplanation>
        <Row>
          <OuterFormColLeft md={6} lg={6}>
            <Field
              name="revocation_period_in_days"
              type="number"
              labelText="Widerrufsfrist"
              component={InputWrapper}
              validate={required()}
              parse={parseStrToNumber}
              disabled={this.props.disabled}
              unit="Tage"
              className="mt-5"
              infoIcon={<Info/>}
              infoIconTooltip="Bei Online Vertragsabschluss steht dem Kunden ein Widerrufsrecht zu. Gesetzlich vorgeschrieben sind 14 Tage."
            />
            <Row>
              <FlexFormCol md={12} lg={12}>
                <Field
                  name="contract_notice_period"
                  type="number"
                  labelText="Kündigungsfrist"
                  component={InputWrapper}
                  validate={combine(
                    required(),
                    numericality({ int: true, msg: "Ungültige Eingabe" }),
                  )}
                  parse={parseStrToNumber}
                  disabled={this.props.disabled}
                  className="mt-5 mr-3"
                />
                <Field
                  name="contract_notice_period_unit"
                  labelText="Einheit"
                  component={SelectWrapper}
                  optionsList={PRODUCT_PARAMETER_PERIOD_OPTIONS}
                  validate={required()}
                  disabled={this.props.disabled}
                  className="mt-5"
                />
              </FlexFormCol>
            </Row>
            {this.renderContractValidityFields(
              automaticProlongation,
              this.props.disabled,
              this.props.isProducer,
            )}
          </OuterFormColLeft>
          <OuterFormColRight md={6} lg={6}>
            <Field
              name="minimum_contract_term"
              type="number"
              labelText="Mindestvertragslaufzeit"
              component={InputWrapper}
              validate={combine(
                required(),
                numericality({ int: true, msg: "Ungültige Eingabe" }),
              )}
              parse={parseStrToNumber}
              disabled={this.props.disabled}
              unit="Monate"
              className="mt-5"
              infoIcon={<Info/>}
              infoIconTooltip="Gesetzlich ist eine Mindestlaufzeit von bis zu zwei Jahren möglich."
            />
            <Field name="is_automatic_prolongation">
              {() => (
                <Switcher
                  switchId={1}
                  labelText="Automatische Vertragsverlängerung"
                  handleChange={() =>
                    form.change(
                      "is_automatic_prolongation",
                      !automaticProlongation,
                    )
                  }
                  isChecked={automaticProlongation}
                  disabled={this.props.disabled}
                  backgroundActiveColor={this.props.disabled ? NO_ACTIVE_BG_COLOR : MAIN_COLOR}
                  className="mt-5"
                  justifyContent="start"
                  activeText="ja"
                  inActiveText="nein"
                  positionText="right"
                  infoIcon={<Info/>}
                  infoIconTooltip="Eine automatische Vertragsverlängerung greift, wenn der Kunde den Vertrag nicht unter Einhaltung der Kündigungsfrist zum Ende der Mindestvertragslaufzeit kündigt."
                />
              )}
            </Field>
          </OuterFormColRight>
        </Row>
        {isSpot && !isRlm && (
          <FallbackTariffSelector
            status={this.props.status}
            fallbackTariff={values.fallback_tariff}
            fallbackTariffOptions={this.props.fallbackTariffOptions}
            disabled={this.props.disabled}
            form={form}
          />
        )}
        <FormNavigation
          onSaveHandler={this.props.onSaveProductOffer}
          onPreviousPageHandler={this.props.onPreviousPage}
          nextTabKey={this.props.nextTabKey}
          previousTabKey={this.props.previousTabKey}
        />
      </Form>
    );
  }
}
ProductContractParameterForm.propTypes = {
  onSaveProductOffer: PropTypes.func.isRequired,
  onPreviousPage: PropTypes.func.isRequired,
  previousTabKey: PropTypes.string.isRequired,
  nextTabKey: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  isProducer: PropTypes.bool
};

const mapStateToProps = (state, ownProps) => ({
  ...ownProps,
  initialValues: state.productOffers.definition.formData,
  fallbackTariffOptions: _.get(
    state,
    "productOffers.definition.data.fallback_tariff_options",
    []
  ),
  status: _.get(state, "productOffers.definition.data.status", "")
});

export default compose(
  connect(mapStateToProps)
)(
  props => (
    <FinalForm
      onSubmit={() => null}
      initialValues={props.initialValues}
      render={({ handleSubmit, form, values }) => {
        if (props.registerFinalForm) {
          props.registerFinalForm(form)
        }

        return (
          <ProductContractParameterForm
            {...props}
            handleSubmit={handleSubmit}
            form={form}
            values={values}
          />
        )
      }}
    />
  )
)